import React, { useState, useEffect } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import { Plus, UserX, KeyRound, X } from 'lucide-react';

const API = 'https://crm.ashbournesystems.ca/api';

const inputStyle = {
  width: '100%', padding: '0.75rem', background: '#0e0804',
  border: '1px solid #2a1a0e', color: '#F5ECD7', fontSize: '0.85rem',
  outline: 'none', boxSizing: 'border-box', marginBottom: '1rem'
};
const labelStyle = {
  display: 'block', fontSize: '0.65rem', color: '#8a6840',
  letterSpacing: '0.12em', marginBottom: '6px'
};
const roleColor = { owner: '#B85A22', admin: '#4F7FA6', staff: '#8a6840' };

export default function Users({ token, role }) {
  const [users, setUsers] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ name: '', last_name: '', email: '', password: '', role: 'staff' });
  const [showPassword, setShowPassword] = useState(false);
  const [resetTarget, setResetTarget] = useState(null);
  const [resetPassword, setResetPassword] = useState('');
  const [resetLoading, setResetLoading] = useState(false);
  const headers = { Authorization: `Bearer ${token}` };

  const load = () => axios.get(`${API}/auth/users`, { headers }).then(r => setUsers(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/auth/register`, form, { headers });
      toast.success(`${form.name} ${form.last_name} added`);
      setShowForm(false);
      setForm({ name: '', last_name: '', email: '', password: '', role: 'staff' });
      load();
    } catch (err) {
      toast.error(err.response?.data?.error || 'Error creating user');
    }
  };

  const deactivate = async (id, name) => {
    if (!window.confirm(`Deactivate ${name}?`)) return;
    try {
      await axios.put(`${API}/auth/users/${id}/deactivate`, {}, { headers });
      toast.success(`${name} deactivated`);
      load();
    } catch { toast.error('Error deactivating user'); }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    if (resetPassword.length < 8) { toast.error('Password must be at least 8 characters'); return; }
    setResetLoading(true);
    try {
      await axios.put(`${API}/auth/users/${resetTarget.id}/password`, { newPassword: resetPassword }, { headers });
      toast.success(`Password reset for ${resetTarget.name}`);
      setResetTarget(null);
      setResetPassword('');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Error resetting password');
    } finally {
      setResetLoading(false);
    }
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' }}>
        <div>
          <h1 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#F5ECD7', marginBottom: '4px' }}>Users</h1>
          <p style={{ color: '#8a6840', fontSize: '0.85rem' }}>{users.length} team member{users.length !== 1 ? 's' : ''}</p>
        </div>
        {(role === 'owner' || role === 'admin') && (
          <button onClick={() => setShowForm(!showForm)} style={{
            display: 'flex', alignItems: 'center', gap: '0.5rem',
            background: '#B85A22', border: 'none', color: '#F5ECD7',
            padding: '0.75rem 1.25rem', cursor: 'pointer', fontSize: '0.82rem', fontWeight: 'bold'
          }}>
            <Plus size={16} /> Add User
          </button>
        )}
      </div>

      {showForm && (
        <div style={{ background: '#1a0f08', border: '1px solid #2a1a0e', borderTop: '3px solid #B85A22', padding: '1.5rem', marginBottom: '2rem' }}>
          <h3 style={{ color: '#F5ECD7', marginBottom: '1.5rem', fontSize: '1rem' }}>New User</h3>
          <form onSubmit={handleSubmit}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
              <div><label style={labelStyle}>FIRST NAME *</label><input style={inputStyle} value={form.name} onChange={e => setForm({...form, name: e.target.value})} required /></div>
              <div><label style={labelStyle}>LAST NAME</label><input style={inputStyle} value={form.last_name} onChange={e => setForm({...form, last_name: e.target.value})} /></div>
              <div><label style={labelStyle}>EMAIL *</label><input style={inputStyle} type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} required /></div>
              <div>
                <label style={labelStyle}>ROLE *</label>
                <select style={inputStyle} value={form.role} onChange={e => setForm({...form, role: e.target.value})}>
                  {role === 'owner' && <option value="admin">Admin</option>}
                  <option value="staff">Staff</option>
                </select>
              </div>
              <div style={{ gridColumn: '1 / -1' }}>
                <label style={labelStyle}>PASSWORD *</label>
                <div style={{ position: 'relative' }}>
                  <input style={{...inputStyle, marginBottom: 0, paddingRight: '3rem'}} type={showPassword ? 'text' : 'password'} value={form.password} onChange={e => setForm({...form, password: e.target.value})} required />
                  <button type="button" onClick={() => setShowPassword(!showPassword)} style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', color: '#8a6840', cursor: 'pointer', fontSize: '0.7rem' }}>
                    {showPassword ? 'HIDE' : 'SHOW'}
                  </button>
                </div>
              </div>
            </div>
            <div style={{ display: 'flex', gap: '1rem', marginTop: '1rem' }}>
              <button type="submit" style={{ background: '#B85A22', border: 'none', color: '#F5ECD7', padding: '0.75rem 1.5rem', cursor: 'pointer', fontWeight: 'bold' }}>Create User</button>
              <button type="button" onClick={() => setShowForm(false)} style={{ background: 'transparent', border: '1px solid #2a1a0e', color: '#8a6840', padding: '0.75rem 1.5rem', cursor: 'pointer' }}>Cancel</button>
            </div>
          </form>
        </div>
      )}

      <div style={{ background: '#1a0f08', border: '1px solid #2a1a0e' }}>
        {users.length === 0 ? (
          <div style={{ padding: '3rem', textAlign: 'center', color: '#8a6840' }}>No users found</div>
        ) : users.map((u, i) => (
          <div key={u.id} style={{
            padding: '1rem 1.5rem', borderBottom: i < users.length - 1 ? '1px solid #2a1a0e' : 'none',
            display: 'flex', justifyContent: 'space-between', alignItems: 'center'
          }}>
            <div>
              <div style={{ color: '#F5ECD7', fontWeight: 'bold', fontSize: '0.9rem' }}>{u.name} {u.last_name}</div>
              <div style={{ color: '#8a6840', fontSize: '0.75rem' }}>{u.email}</div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
              <span style={{ fontSize: '0.62rem', color: roleColor[u.role] || '#8a6840', border: `1px solid ${roleColor[u.role] || '#2a1a0e'}`, padding: '2px 8px' }}>
                {u.role?.toUpperCase()}
              </span>
              <span style={{ fontSize: '0.62rem', color: u.is_active ? '#4a9a4a' : '#8b2020' }}>
                {u.is_active ? 'ACTIVE' : 'INACTIVE'}
              </span>
              {role === 'owner' && u.role !== 'owner' && (
                <>
                  <button onClick={() => setResetTarget(u)} style={{ background: 'transparent', border: '1px solid #4F7FA6', color: '#4F7FA6', padding: '0.35rem 0.6rem', cursor: 'pointer', fontSize: '0.7rem', display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <KeyRound size={11} /> Reset PW
                  </button>
                  {u.is_active && (
                    <button onClick={() => deactivate(u.id, `${u.name} ${u.last_name}`)} style={{ background: 'transparent', border: '1px solid #8b2020', color: '#8b2020', padding: '0.35rem 0.6rem', cursor: 'pointer', fontSize: '0.7rem', display: 'flex', alignItems: 'center', gap: '4px' }}>
                      <UserX size={11} /> Deactivate
                    </button>
                  )}
                </>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Reset Password Modal */}
      {resetTarget && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 300, background: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          onClick={() => setResetTarget(null)}>
          <div style={{ background: '#1a0f08', border: '1px solid #2a1a0e', borderTop: '2px solid #B85A22', padding: '2rem', width: '100%', maxWidth: '360px', margin: '1rem' }}
            onClick={e => e.stopPropagation()}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
              <h3 style={{ color: '#F5ECD7', fontSize: '1rem', margin: 0, fontFamily: 'Georgia, serif' }}>Reset Password</h3>
              <button onClick={() => setResetTarget(null)} style={{ background: 'none', border: 'none', color: '#8a6840', cursor: 'pointer' }}><X size={18} /></button>
            </div>
            <div style={{ color: '#8a6840', fontSize: '0.8rem', marginBottom: '1.25rem' }}>
              Setting new password for <span style={{ color: '#F5ECD7' }}>{resetTarget.name} {resetTarget.last_name}</span>
            </div>
            <form onSubmit={handleResetPassword}>
              <label style={labelStyle}>NEW PASSWORD</label>
              <input type="password" style={inputStyle} value={resetPassword} onChange={e => setResetPassword(e.target.value)} required />
              <div style={{ display: 'flex', gap: '0.75rem' }}>
                <button type="submit" disabled={resetLoading} style={{ flex: 1, padding: '0.75rem', background: '#B85A22', border: 'none', color: '#F5ECD7', cursor: 'pointer', fontSize: '0.75rem', letterSpacing: '0.1em', fontWeight: 'bold' }}>
                  {resetLoading ? 'RESETTING...' : 'RESET PASSWORD'}
                </button>
                <button type="button" onClick={() => setResetTarget(null)} style={{ padding: '0.75rem 1rem', background: 'transparent', border: '1px solid #2a1a0e', color: '#8a6840', cursor: 'pointer', fontSize: '0.75rem' }}>
                  CANCEL
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}